module.exports = __webpack_public_path__ + "static/alpa-08fe5f08e8837da1064c4fc7d82e340d.jpg";